import React from 'react';
import Icon from '../../../components/AppIcon';

const MultipleChoiceQuestion = ({ question, selectedAnswer, onAnswerSelect, showFeedback, isCorrect }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
          {question?.text}
        </h2>
        {question?.context && (
          <p className="text-sm md:text-base text-muted-foreground">
            {question?.context}
          </p>
        )}
      </div>
      <div className="grid grid-cols-1 gap-3 md:gap-4">
        {question?.options?.map((option) => {
          const isSelected = selectedAnswer === option?.id;
          const isCorrectAnswer = showFeedback && option?.isCorrect;
          const isWrongAnswer = showFeedback && isSelected && !option?.isCorrect;

          return (
            <button
              key={option?.id}
              onClick={() => !showFeedback && onAnswerSelect(option?.id)}
              disabled={showFeedback}
              className={`
                w-full min-h-[60px] md:min-h-[72px] p-4 md:p-5 rounded-xl border-2 text-left transition-smooth
                ${isSelected && !showFeedback ? 'border-primary bg-primary/5' : 'border-border bg-card'}
                ${isCorrectAnswer ? 'border-success bg-success/5' : ''}
                ${isWrongAnswer ? 'border-destructive bg-destructive/5' : ''}
                ${!showFeedback ? 'hover:border-primary/50 hover:bg-muted cursor-pointer' : 'cursor-default'}
              `}
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className={`
                  flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-smooth
                  ${isSelected && !showFeedback ? 'border-primary bg-primary' : 'border-border'}
                  ${isCorrectAnswer ? 'border-success bg-success' : ''}
                  ${isWrongAnswer ? 'border-destructive bg-destructive' : ''}
                `}>
                  {isSelected && !showFeedback && (
                    <Icon name="Check" size={14} color="#FFFFFF" />
                  )}
                  {isCorrectAnswer && (
                    <Icon name="Check" size={14} color="#FFFFFF" />
                  )}
                  {isWrongAnswer && (
                    <Icon name="X" size={14} color="#FFFFFF" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground">
                    {option?.text}
                  </p>
                  {showFeedback && option?.explanation && (isCorrectAnswer || isWrongAnswer) && (
                    <p className="mt-2 text-xs md:text-sm text-muted-foreground">
                      {option?.explanation}
                    </p>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MultipleChoiceQuestion;